import { render, staticRenderFns } from "./Fname.vue?vue&type=template&id=ad28f20a"
import script from "./Fname.vue?vue&type=script&lang=js"
export * from "./Fname.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports